import { Plus } from 'lucide-react';
import { DataTable } from '../../../../design-system/data-table/data-table';
import { PayrollView } from '../../../../types/entity-types';
import { payrollTableColumnsDefinition } from './payroll-table-column-definition';

type PayrollTableProps = {
  payrolls: PayrollView[];
  handleNewPayroll: () => void;
  onSelectPayroll?: (payroll: PayrollView) => void;
  className?: string;
};

export const PayrollTable = ({ payrolls, handleNewPayroll, onSelectPayroll, className }: PayrollTableProps) => {
  const handleRowSelect = (id: string) => {
    if (onSelectPayroll) {
      const payroll = payrolls.find((p) => p.id === id);
      if (payroll) {
        onSelectPayroll(payroll);
      }
    }
  };

  return (
    <DataTable
      columns={payrollTableColumnsDefinition}
      data={payrolls}
      onSelectRow={handleRowSelect}
      showPagination={true}
      className={className}
      filters={{
        show: true,
        globalSearchConfig: { withGlobalSearch: true, placeholder: 'Search payrolls' },
        enableDateRangeFilter: false,
        columns: [{ accessor: 'status', label: 'Status', search: { show: false } }],
      }}
      tableActionButtonConfig={{
        primary: { isVisible: true, text: 'New Payroll', onClick: handleNewPayroll, icon: <Plus /> },
        secondary: { isVisible: false },
      }}
      initialSorting={[{ id: 'status', desc: false }]}
    />
  );
};
